<template>
  <div class="header">
    <div class="container-fluid">
      <!-- Hearer  -->
      <div class="mt-4">
        <div class="card">
          <div class="card-body">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item fw-bolder">Master Data</li>
                <li class="breadcrumb-item">Organizations</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <!-- Card  -->
      <div class="card mt-5">
        <div class="card-header">
          <!-- Title -->
          <h4 class="card-header-title">Organizations</h4>
          <!-- Button -->
          <b-button v-if="isCreat" v-b-modal.modal-1 variant="primary" @click="addNew">
            <span class="fe fe-user-check mr-2"></span>
            Create New
          </b-button>
        </div>
        <div class="card-body">
          <div>
            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label>Name</label>
                  <input name="name" type="text" class="form-control" v-model.trim="body.name" @input="handleNameInput" />
                </div>
              </div>
              <div class="col-lg-2">
                <b-button variant="primary" class="mt-4" @click="searchData">Filter</b-button>
                <b-button variant="primary" class="ml-1 mt-4" @click="resetFilterData">Reset Filter
                </b-button>
              </div>
            </div>
          </div>
        </div>
            <vue-good-table
            :line-numbers="true"
            :columns="columns"
            :rows="list.data"
            :sort-options="{
                        enabled: true,
                    }"
            :total-rows="list.totalItems"
            :pagination-options="{
                        enabled: true,
                        perPage: body.perPage,
                    }"
            style-class="vgt-table border-0 table"
            @on-page-change="onPageChange"
            @on-per-page-change="onPageChange"
            @on-sort-change="onSortChange">
            <template v-slot:columns.company="{ index, item }">
              <span class=""> {{ item }}</span>
            </template>
          <!-- Loading -->
          <div slot="emptystate" class="text-center font-size-14">
            No data available
          </div>
          <!-- Custom Rows -->

          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'is_divisi'">
              {{props.row.is_divisi ? 'Divisi' : 'Department'}}
            </span>
            <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
            <!-- Table Action -->
            <span v-if="props.column.field == 'action'">
              <b-button class="no-wrap btn-pill" variant="secondary" size="sm"
                        @click="detailData(props.row.id)">
                  <span class="fe fe-search"></span>
              </b-button>
              <b-button v-if="isUpdate" class="no-wrap btn-pill ml-2" variant="warning" size="sm" @click="editData(props.row.id)">
                  <span class="fe fe-edit"></span>
              </b-button>
              <b-button v-if="isDelete" class="no-wrap ml-2" variant="danger" style="margin-left: 5px" size="sm"
                        @click="deleteData(props.row.id)">
                  <span class="fe fe-trash-2"></span>
              </b-button>
          </span>
          </template>
          <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-end">
              <div>
                <b-pagination :value="1" :total-rows="list.totalItems" :per-page="body.pageSize"
                              first-number last-number align="right" prev-class="prev-item" next-class="next-item"
                              class="mr-3 mb-4 mt-0"
                              @input=" (value) => props.pageChanged({ currentPage: value })">
                </b-pagination>
              </div>
            </div>
          </template>
        </vue-good-table>

      </div>
    </div>
  </div>
</template>

<script>
import ToggleSwitch from "@/components/ToggleSwitch.vue";
import axiosIns from "@/api/axios";

export default {
  name: "ListOrgChart",
  components: {ToggleSwitch},
  computed: {
    /*index() {
      return index
    },*/
    list() {
      return this.$store.getters["masterOrgChart/listData"];
    },

  },
  data() {
    return {
      body: {
        pageNumber: 1,
        pageSize: 10,
        search: "",
        field: "",
        order: "",
        name: ""
      },
      modalDetail: {
        fullname: "",
        email: "",
        contact: "",
        role: "",
        divisi: "",
        department: "",
        subordinate_department: "",
        subordinate_member: "",
        budget_plan: "",
        created_at: "",
        created_by: "",
        updated_at: "",
        updated_by: ""
      },
      id: "",
      isAdd: true,
      isLoading: false,
      columns: [
          {
            label: "Name",
            field: "name",
            thClass: "table-header no-wrap w-40 text-muted font-weight-bold",
            tdClass: "no-wrap color-secondary align-middle",
          },
        {
          label: "Action",
          field: "action",
          sortable: false,
          thClass: "table-header no-wrap w-40 text-muted font-weight-bold text-center",
          tdClass: "no-wrap color-secondary align-middle text-center",
        },
      ],
      listRole: [],
      selectedRole: null,
      paramName: null,
      paramEmail: null,
      paramRole: null,
      isRead: false,
      isCreat: false,
      isUpdate: false,
      isDelete: false
    };
  },

  mounted() {
    this.checkPermission();
    this.getList();
    this.getListRole();
    this.role_id = localStorage.getItem('roles')
  },
  methods: {
    async checkPermission() {
      const roleName = localStorage.getItem("roles");
      const roleId = await axiosIns.get("/master-role/find-name?name=" + roleName);
      const menuId = await axiosIns.get("/master-menu/find-link?link=" + this.$route.path);
      const payloadPermission = {
        role_id: roleId.data.data[0]?.id || null,
        menu_id: menuId.data.data[0]?.id || null
      }
      const checkAuth = await axiosIns.post("/master-role/check-permission", payloadPermission);
      if(checkAuth.data.data?.authorization){
        this.isRead = checkAuth.data.data?.authorization.includes('read')
        this.isCreat = checkAuth.data.data?.authorization.includes('create')
        this.isUpdate = checkAuth.data.data?.authorization.includes('update')
        this.isDelete = checkAuth.data.data?.authorization.includes('delete')
      }
    },
    detailData(id) {
      this.$router.push(`/master-data/org-chart/detail?id=${id}`)
    },
    editData(id) {
      this.$router.push(`/master-data/org-chart/edit?id=${id}`)
    },
    addNew() {
      this.$router.push(`/master-data/org-chart/add`)
    },

    getList() {
      this.$store.dispatch('masterOrgChart/GET_LIST_DATA', this.body)
    },
    async getListRole() {
      try {
        this.$store.dispatch('masterRole/GET_LIST_DATA', this.body).then(res => {
        })
        const response = await axiosIns.get("/master-role");
        this.listRole = response.data.data.data.map(items => ({
          label: items.roles_name,
          value: items.id
        }));
      } catch (error) {
        console.error("Failed to fetch year options:", error);
      }

    },
    deleteData(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
              .dispatch("masterOrgChart/DELETE_DATA", id)
              .then((resp) => {
                this.getList();
                this.$swal("Deleted!", "Your file has been deleted", "success");
              })
              .catch((resp) => {
                this.$swal("Error", "Error while delete data", "error");
              });
        }
      });
    },

    // filter
    filterPage() {},

    sorting() {
      this.getList();
    },

    // Pagination
    onPageChange(payload) {
      this.body.limit = payload.currentPerPage;
      this.body.page = payload.currentPage;
      this.getList();
    },
    onSortChange(params) {
      let sort1 = params[0].field;
      let sort2 = params[0].type;
      this.body.field = sort1
      if (sort2 == 'none') {
        this.body.order = ''
      } else {
        this.body.order = sort2
      }
      this.getList();
    },
    searchData() {
      this.isLoading = true
      //let body = {}
      if (this.paramName !== null && this.paramName !== '') {
        this.body.name = this.paramName
      }
      if (this.paramEmail !== null && this.paramEmail !== '') {
        this.body.email = this.paramEmail
      }
      if (this.paramRole !== null && this.paramRole !== '') {
        this.body.role_id = this.paramRole
      }
      this.getList();
      /*this.$store.dispatch("budgetMonitor/GET_LIST_MONITOR", body).then((resp) => {
        this.isLoading = false
      })*/
    },
    resetFilterData() {
      this.isLoading = true
      this.body.name = null;
      this.body.email = null;
      this.body.role_id = null;
      this.getList();
    },
    handleNameInput() {
      if (this.body.name.length >= 3) {
        this.searchData()
      }else{
        this.getList();
      }
    }
  },
};
</script>
